export default __webpack_public_path__ + "static/media/fabian.png.webp";